import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { useMobxStores } from '@stores/store';
import queryString from 'query-string';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PlayBtn from '@atoms/btn/PlayBtn';

const SectionMedia = () => {
  const { i18n, t } = useTranslation();
  const { settingStore } = useMobxStores();
  const [onActiveIndex, setOnActiveIndex] = useState(0);

  const sectionStyle = {
    backgroundImage: 'url(/img/v2/main/mobile/bg/bg_butter.png)',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
  };

  const boxStyle = {
    backgroundImage: 'url(/img/v2/main/mobile/media_box.png)',
    backgroundSize: '100%',
    backgroundPosition: 'top',
    backgroundRepeat: 'no-repeat',
  };

  const arrayMediaTitle = [
    '이름 짓기',
    '로고 만들기',
    '퍼즐 만들기',
    '제작 후기',
  ];

  const arrayMedia = [
    '34u9lJWBLMc',
    'GeTdXJNxON4',
    'I6kNDR1MGBQ',
    'MG-KYIvBzzs',
  ];
  const handleClickChange = () => {
    settingStore.setCommonDialogState(true);
    settingStore.setCommonDialogSrcState(arrayMedia[onActiveIndex]);
  };

  useEffect(() => {}, []);

  return (
    <>
      <section
        className="media bg-[#f8f8f8] py-2 relative"
        style={sectionStyle}
      >
        <img
          src="/img/v2/main/mobile/media_butter.png"
          className="top-[20px] left-0 right-0 w-full"
        />

        <div className="px-5 text-center ">
          <p className="font-extrabold  top-0 left-0 right-0 font-TmoneyRoundWind  text-[#e5b522] #xxxs:text-3xl text-4xl xs:text-5xl">
            {t('BTS')}
          </p>
          <p className=" font-extrabold top-0 left-0 right-0 font-TmoneyRoundWind  text-[#e5b522] #xxxs:text-3xl text-4xl xs:text-5xl">
            {t('게임개발자 되다!')}
          </p>
          <p className="text-[#c5a43f]  text-md sm:text-xl py-2">
            {t('이름부터 로고, 퍼즐까지 함께한 과정을 알아봐요')}
          </p>
          <div
            className="relative pt-[26.5%] px-[18px] pb-[63%] xs:px-[30px] md:px-[55px] media-container"
            style={boxStyle}
          >
            <div className="media-container-ratio">
              <div className="grid grid-cols-4 media-menu font-TmoneyRoundWind">
                {arrayMediaTitle &&
                  arrayMediaTitle.map((title, idx) => (
                    <div
                      className={` text-sm xs:text-lg ${
                        onActiveIndex === idx ? 'active' : ''
                      }`}
                      onClick={() => setOnActiveIndex(idx)}
                      key={`media_${idx}`}
                    >
                      <span className="font-extrabold  #xxs:text-[8px] inline-block pb-[8px] xxs:pb-[2px] px-[2px]">
                        {t(arrayMediaTitle[idx])}
                      </span>
                    </div>
                  ))}
              </div>
              <div className="relative" onClick={handleClickChange}>
                <PlayBtn />
                <div className="pt-[1%] px-[2%]">
                  <img
                    src={`/img/v2/main/media/media_img_0${onActiveIndex}.jpg`}
                    alt=""
                    className=" object-cover rounded-[3px] border border-solid border-[#e5dd7d] w-full h-full "
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="absolute bottom-[10%] flex left-[15px] right-0 justify-center   ">
            <a
              href="https://www.youtube.com/@IntheSEOM"
              target="_blank"
              className="mx-[20%]  py-1 w-full flex justify-center items-center bg-[#cb3c2e] rounded-full w-full text-[#fff] font-bold btn-shadow text-center py-3 xs:py-5 xs:text-2xl"
              rel="noreferrer"
            >
              {t('공식 유튜브')}
              <img
                src="/img/v2/svg/youtube.svg"
                alt=""
                className="inline-block max-h-[30px] ml-2"
              />
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default observer(SectionMedia);
